module.exports = __webpack_public_path__ + "gm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gm.svg
// module id = 571
// module chunks = 0